import { render, staticRenderFns } from "./StoreCalling.vue?vue&type=template&id=fc2ae7d6&scoped=true&"
import script from "./StoreCalling.vue?vue&type=script&lang=js&"
export * from "./StoreCalling.vue?vue&type=script&lang=js&"
import style0 from "./StoreCalling.vue?vue&type=style&index=0&id=fc2ae7d6&lang=less&scoped=true&"
import style1 from "./StoreCalling.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2ae7d6",
  null
  
)

export default component.exports